module.exports = __webpack_public_path__ + "static/media/yves-saint-lhomme-parfum-intentse-big.c92b74e6.png";